<template>
    <div class="gift-bag-box">
        <div class="gift-box"  id="receive-gift" @click="showGiftModal">
        </div>
        <div class="gift-modal_show" style="width: 100%; height: 100vh; z-index: 99999; background: rgba(0, 0, 0,0.8); position: fixed; top: 0px;left: 0;backdrop-filter: blur(2px);">
            <div class="vi-c" style="width:13.3rem;position: fixed;top: 50%;left: 50%;transform: translate(-50%, -50%);z-index: 99999;">
            <img class="close_gift" @click="closeGiftModal" id="close_video" src="http://dftk-hw-cdn-ali.yingxiong.com/web/c_tank/assets/gift-close.png" alt=""
                    style="position: absolute;right: 0.35rem;top: .52rem;cursor: pointer;height: 0.3rem;width:.3rem;z-index: 99999;">
            <div class="gift-modal">
                <div class="gift-code" id="gift-code" @click="copyGiftCode">
                    <!-- <img src="{HOME_THEME_PATH}web/img/gift-code-icon.png" alt="礼包码"> -->
                </div>
                <div class="copy-tip">
                    <img src="../assets/gift-tip-en.png" alt="">
                </div>
            </div> 
            
            </div>
        </div>
        
    </div>
  </template>
  <script>
  export default {
    name: 'giftpackageEn',
    data() {
      return {
        
      };
    },
    components: {
    },
    watch: {
        $route: {
            immediate: true,
            handler(to, from) {
            
            },
        },
    },
    computed: {
      
    },
    mounted () {
       
    },
    beforeDestroy() {
       
    },
    methods: {
        showGiftModal() {
            document.querySelector('.gift-modal_show').style.visibility = 'visible';
        },
        closeGiftModal() {
            document.querySelector('.gift-modal_show').style.visibility = 'hidden';
        },
        copyTextToClipboard(text) {
            // 尝试使用Clipboard API  
            if (navigator.clipboard && navigator.clipboard.writeText) {  
                navigator.clipboard.writeText(text).then(function() {  
                    console.log('Text copied to clipboard using Clipboard API');  
                    showCopyTip(true);
                    }).catch(function(err) {  
                    console.error('Failed to copy text using Clipboard API:', err);  
                    // Clipboard API失败时回退到旧方法  
                    fallbackToExecCommand(text);
                });  
            } else {  
                // Clipboard API不支持，直接使用旧方法  
                fallbackToExecCommand(text);
            }  
            // 封装显示和隐藏复制提示的逻辑  
            function showCopyTip(isVisible) {
                const $copyTip = document.querySelector('.copy-tip');
                if ($copyTip){
                    $copyTip.style.visibility = isVisible ? 'visible' : 'hidden';
                    if (isVisible) {  
                        setTimeout(function() {  
                            $copyTip.style.visibility = 'hidden';
                        }, 1200); 
                    } 
                }
                 
            }  
            
            // 封装回退到document.execCommand的逻辑  
            function fallbackToExecCommand(text) {  
                const textarea = document.createElement("textarea");  
                textarea.value = text;  
                textarea.style.position = 'fixed'; // 防止滚动条移动  
                textarea.style.left = '-9999px'; // 隐藏元素  
                document.body.appendChild(textarea);  
                textarea.select();  
                try {  
                const successful = document.execCommand('copy');  
                const msg = successful ? 'successful' : 'unsuccessful';  
                console.log('Copying text command was ' + msg);  
                showCopyTip(true); // 显示复制提示  
                } catch (err) {  
                console.error('Failed to copy text using document.execCommand:', err);  
                }  
                document.body.removeChild(textarea);  
            }  
        },
        debounce(func, delay) {  
            var timer; // 注意这里使用var而不是let，因为这是在ES5的环境下  
            
            // 返回一个匿名函数，这个函数将在每次被调用时执行防抖逻辑  
            return function() {  
                var context = this; // 保存调用上下文  
                var args = arguments; // 保存调用参数  
            
                // 清除之前的定时器（如果存在）  
                if (timer) {  
                    clearTimeout(timer);  
                }  
            
                // 设置新的定时器  
                timer = setTimeout(function() {  
                // 当定时器到达设定的时间后，执行原函数  
                    func.apply(context, args); // 使用apply来保持原函数的this上下文和参数  
                }, delay);  
            };  
        },
        createDebouncedCopyFunction(text, wait) {
            let that = this;
            return this.debounce(function() {  
                that.copyTextToClipboard(text);  
            }, wait);  
        },
        copyGiftCode() {
            const debouncedCopy = this.createDebouncedCopyFunction('TKUR5RWC', 300);
            debouncedCopy();
        }
    }
  };
  </script>
  <style lang='scss' scoped>
  .gift-bag-box{
    position: fixed;
    /* right: 0.16rem; */
    top: 33%;
    /* width: 2.51rem;
    height: 2.4rem; */
    width: 2.64rem;
    height: 2.62rem;
    right: 0;
    box-sizing: border-box;
    z-index: 998;
  }
  .gift-box{
    display: inline-block;
    width: 100%;
    height: 100%;
    background: url("../assets/gift-apng-en.png") no-repeat center;
    background-size: 100% 100%;
    cursor: pointer;
    padding: 0.15rem;
    box-sizing: border-box;
    transition: all .3s;
  }
  
  .gift-bag-box .gift-info{
    width: 1.14rem;
    height: 0.2rem;
    position: relative;
  }
  .gift-bag-box .receive-btn{
    width: .96rem;
    height: 0.2rem;
    /* line-height: 0.2rem; */
    background: linear-gradient(360deg, #FFF4C6 0%, #FEFEFD 100%);
    transform: skew(-10deg);
    border-radius: 1px;
    position: absolute;
    left: 0;
    top: 0;
    
  }
  .gift-bag-box .text{
    height: 0.2rem;
    width: .96rem;
    font-size: 13px;
    line-height: 0.2rem;
    color: #111418;
    display: -webkit-flex; /* Safari */
    -webkit-align-items: center; /* Safari 7.0+ */
    -webkit-justify-content: center;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0;
    top: 0;
  }
  .gift-bag-box .text span{
    display: none;
    margin-top: 1px;
  }
  .gift-box:hover{
    transform: scale(1.02);
    transform-origin: 70% 50%;
  }
  @media screen and (max-width: 1520px) {
    .gift-bag-box .text{ 
      font-size: 12px;
    }
    /* .gift-bag-box:hover .text{
      line-height: 0.21rem;
    } */
  }
  @media screen and (max-width: 1440px) {
    .gift-bag-box .text{ 
      font-size: 12px;
      transform: scale(0.9);   
    }
    /* .gift-bag-box:hover .text{
      line-height: 0.21rem;
    } */
  }
  .gift-bag-box .gift-modal{
    /* position: fixed;
    right: 50%;
    top: 30%;
    width: 2.64rem;
    height: 0.96rem;
    box-sizing: border-box; */
  }
  .gift-modal_show{
    visibility: hidden;
  }
  .gift-modal_show .gift-modal{
    width: 13.32rem;
    height: 5.32rem;
    background: url('../assets/giftpackage-bgicon-en.png') no-repeat center;
    background-size: 100% auto;
    position: relative;
  }
  .gift-modal_show .gift-modal .gift-code{
    position: absolute;
    bottom: 1.35rem;
    right: 0.3rem;
    width: 2.52rem;
    height: 0.91rem;
    cursor: pointer;
  }
//   .gift-modal_show .gift-modal .gift-code img{
//     width: 100%;
//     height: auto;
//   }
  .gift-modal_show .gift-modal .copy-tip{
    position: absolute;
    top: 1.91rem;
    left: 0;
    width: 100%;
    height: 1.06rem;
    visibility: hidden;
  }
  .gift-modal_show .gift-modal .copy-tip img{
    width: 100%;
    height: auto;
  }
  </style>
  
  